import React, { useEffect, useState, useContext } from "react";
//import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import pageClasses from "./page.module.css";
import QRscanner from "../components/QRscanner";
import { parseQRtoElements } from "../tools/qroperations";
import { enquireBox } from "../api/api";
import { LookContext } from "../Contexts/LookContext";
import MyButton from "../components/MyButton";
import MySpinner from "../components/MySpinner";
import ModalAlert from "../components/modals/ModalAlert";
import ModalInfo from "../components/modals/ModalInfo";
import "./login.css";

function QRscannerpage() {
  const [qrString, setQrString] = useState("no string");
  const [scan, setScan] = useState(false);
  const [goodQR, setGoodQR] = useState(false);
  const [box, setBox] = useState({});
  const [enquiryResponse, setEnquiryResponse] = useState(null);
  const [serialNumber, setSerialNumber] = useState("");
  const [isInvalidSerialNumber, setIsInvalidSerialNumber] = useState(false);
  const [showModalAlert, setShowModalAlert] = useState(false);
  const [modalAlertMessage, setModalAlertMessage] = useState("An Error!");
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [modalInfoMessage, setModalInfoMessage] = useState("Info Message!");
  const [isBusy, setIsBusy] = useState(false);

  const isMobile = useContext(LookContext);

  useEffect(() => {
    console.log("++++++++++++++++++++++++++++++++++++++++++++++");
    console.log(
      `This is enquiry page, and isMobile has changed to: ${isMobile}`,
    );
    console.log("++++++++++++++++++++++++++++++++++++++++++++++");
  }, [isMobile]);

  useEffect(() => {
    if (enquiryResponse) {
      setIsBusy(false);
      console.log(`Got a response for box: ${JSON.stringify(enquiryResponse)}`);
      if (enquiryResponse.success) {
        if (enquiryResponse.available) {
          //setModalInfoMessage(`Box with serial number ${enquiryResponse.serialNumber} is available. Box details: ${JSON.stringify(enquiryResponse.boxDetails)}.`);
          const boxDetails = enquiryResponse.boxDetails || {};
          const detailsText = Object.entries(boxDetails)
            .map(([key, value]) => `${key}: ${value}`)
            .join("\n");

          setModalInfoMessage(
            `✅ Box with serial number ${enquiryResponse.serialNumber} is available.\n\n${detailsText}`,
          );
          setShowModalInfo(true);
          setModalAlertMessage(null);
          setShowModalAlert(false);
        } else {
          setModalInfoMessage(
            `❌ Box with serial number ${enquiryResponse.serialNumber} is not available.`,
          );
          setShowModalInfo(true);
          setModalAlertMessage(null);
          setShowModalAlert(false);
        }
      } else {
        console.log(
          `Unable to enquire box with SN: ${enquiryResponse.serialNumber}, message: ${enquiryResponse.message}.`,
        );
        setModalAlertMessage(
          `❌ Unable to enquire box with SN: ${enquiryResponse.serialNumber}, message: ${enquiryResponse.message}.`,
        );
        setShowModalAlert(true);
        setModalInfoMessage(null);
        setShowModalInfo(false);
      }


      setSerialNumber("");
      setIsInvalidSerialNumber(false);
      setIsBusy(false);
      setEnquiryResponse(null);
    }
  }, [enquiryResponse]);

  useEffect(() => {
    console.log(`scan: ${scan}, goodQR: ${goodQR}.`);
  }, []);

  const displayError = (error) => {
    console.log(`Problem in reading qr string: ${error}`);
  };

  const handleReadString = (Readqrstring) => {
    console.log(`read qrstring is: ${Readqrstring}.`);
    setQrString(Readqrstring);
    const box = parseQRtoElements(Readqrstring);
    if (box) {
      setBox(box);
      setGoodQR(true);
      setScan(false);
    } else {
      setGoodQR(false);
      console.log("invalid qr string.");
    }
  };

  const handleScanButton = () => {
    setScan(true);
    setModalInfoMessage(null);
    setShowModalInfo(false);
    setModalAlertMessage(null);
    setShowModalAlert(false);
  };

  const handleEnquireUsingNumber = () => {
    //check if serial number is valid
    if (!serialNumber || isNaN(serialNumber) || serialNumber <= 0) {
      setIsInvalidSerialNumber(true);
      return;
    }
    //call the enquireBox function from the api.js file, and pass the serial number and the setEnquiryResponse function as parameters
    try {
      enquireBox(serialNumber, setEnquiryResponse);
      setIsBusy(true);
    } catch (error) {
      console.log(`Error in enquiring box: ${error}.`);
    }
  };

  const handleEnquireScan = () => {
    console.log(`This is handleEnquireScan: ${JSON.stringify(box)}.`);

    const { serialNumber, ...rest } = box;

    if (serialNumber) {
      try {
        enquireBox(serialNumber, setEnquiryResponse);
        setIsBusy(true);
      } catch (error) {
        console.log(`Error in enquiring box: ${error}.`);
      }
    }
    setGoodQR(false);
    setScan(false);
    setQrString("no string");
  };

  return (
    <div className={pageClasses.pagebody}>
      <h1 className={pageClasses.pageTitle}>مسح الملصق</h1>
      <div div className="number_container">
        <TextField
          type="number"
          id="serialNumber"
          className="input_element"
          label="Serial Number"
          autoComplete="off"
          onChange={(e) => {
            setIsInvalidSerialNumber(false);
            setSerialNumber(e.target.value);
          }}
          value={serialNumber}
          error={isInvalidSerialNumber}
          helperText={isInvalidSerialNumber ? "Invalid Serial Number" : ""}
          required
        />

        <div className="button_div">
          <MyButton
            variant={"primary"}
            onClickHandler={handleEnquireUsingNumber}
            title={`استعلام بالرقم`}
          />
        </div>
      </div>
      {!scan && (
        <button
          className={pageClasses.button}
          variant="contained"
          onClick={handleScanButton}
        >
          إضغط للمسح
        </button>
      )}
      {goodQR && (
        <button
          className={pageClasses.button}
          variant="contained"
          onClick={handleEnquireScan}
        >
          إضغط للاستعلام
        </button>
      )}
      <h2 className={pageClasses.qrString}>
        {" "}
        {`QR String for box: ${qrString}`}
      </h2>
      {scan && (
        <QRscanner
          className={pageClasses.scanner}
          scanHandler={handleReadString}
          errorHandler={displayError}
        />
      )}

      <ModalAlert
        show={showModalAlert}
        alertMessage={modalAlertMessage}
        handleClose={() => {
          setShowModalAlert(false);
        }}
      />

      <ModalInfo
        show={showModalInfo}
        infoMessage={modalInfoMessage}
        handleClose={() => {
          setShowModalInfo(false);
        }}
      />
      {isBusy && <MySpinner />}
    </div>
  );
}

export default QRscannerpage;
